import axios from 'axios';
import { baseUrl } from '@/config';
import kebabCase from 'lodash/kebabCase';

export default {
  /**
   * [성능/운영>요약] 무선 장비 (AP 컨트롤러) 성능위젯 정보 조회 (후면)
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSummaryRscRsltBackList(params) {
    const widgetKey = params.summaryWidgetKey;
    // AP 컨트롤러
    if (widgetKey === 'CLIENT' || widgetKey === 'ROGUE' || widgetKey === 'WIRELESSAP_TOPN') {
      return axios.post(`${baseUrl}/performance/summary/ap-controller/get-${kebabCase(widgetKey)}-rsc-rslt-list.do`, params);
    }
    return axios.post(`${baseUrl}/performance/summary/netdevice/get-${widgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },
  /**
   * [성능/운영>요약] 무선 장비 (AP 컨트롤러) 구성 정보 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getConfigurationInfo(params) {
    return axios.post(`${baseUrl}/performance/summary/ap-controller/get-configuration-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/ap-controller/ap-controller.js